import type { TextOverlayOption, TextOverlayScene, TextOverlayType } from '../types';

export const DEFAULT_TEXT_OVERLAY_CONTINUE_TEXT = 'Continuer';
export const DEFAULT_TEXT_OVERLAY_TYPE = 'letter' as const;

export const PLAYABLE_TEXT_OVERLAY_TYPES = [
  'email',
  'console',
  'terminal',
  'letter',
  'cyber',
  'poster',
  'note',
  'document',
  'summary',
] as const satisfies ReadonlyArray<Exclude<TextOverlayType, 'chapterEnd'>>;

export type PlayableTextOverlayType = (typeof PLAYABLE_TEXT_OVERLAY_TYPES)[number];

export function resolveTextOverlayType(
  overlayType?: string | null
): PlayableTextOverlayType {
  if (
    overlayType
    && (PLAYABLE_TEXT_OVERLAY_TYPES as readonly string[]).includes(overlayType)
  ) {
    return overlayType as PlayableTextOverlayType;
  }
  return DEFAULT_TEXT_OVERLAY_TYPE;
}

export function resolveTextOverlayOptions(
  scene: Pick<TextOverlayScene, 'options' | 'continueText'> | null | undefined
): TextOverlayOption[] {
  if (!scene) return [];
  if (scene.options?.length) return scene.options;
  const text = scene.continueText?.trim();
  if (text) return [{ text }];
  return [];
}
